module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('simple-modal', {
    staticClass: "fade",
    attrs: {
      "id": "login-modal"
    }
  }, [_vm._t("caption", [_vm._v("ログイン有効期限が切れました。お手数ですが再度ログインしてください。")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "userID"
    }
  }, [_vm._v("ユーザー名（メールアドレス）")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credencials.email),
      expression: "credencials.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "mail",
      "placeholder": "ユーザー名（メールアドレス）"
    },
    domProps: {
      "value": (_vm.credencials.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credencials.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb-5"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "pass"
    }
  }, [_vm._v("パスワード")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credencials.password),
      expression: "credencials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "パスワード"
    },
    domProps: {
      "value": (_vm.credencials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.credencials.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('button', {
    ref: "dismissBtn",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    class: _vm.loginButtonStyle,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    },
    slot: "footer"
  }, [_vm._v("ログイン")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-342a568a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/LoginModal.vue
// module id = 325
// module chunks = 1